import { Component } from 'react';

/**
 * AppErrorBoundary — filet global anti écran blanc (S15 09/08).
 * Toute erreur de rendu non rattrapée (page, chunk lazy, provider) tombe ici
 * au lieu de laisser un écran noir/blanc muet. Le backend n'est pas concerné :
 * les erreurs API restent gérées écran par écran (toasts / états d'erreur).
 */
export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erreur de rendu non rattrapée :', error, errorInfo?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-fallback"
          className="min-h-screen flex items-center justify-center bg-black p-8"
        >
          <div className="max-w-md text-center">
            <div className="text-5xl mb-3">⚠️</div>
            <h1 className="text-lg font-semibold text-white mb-1">
              Une erreur est survenue
            </h1>
            <p className="text-sm text-neutral-400 mb-4">
              L'écran n'a pas pu s'afficher. Vos données ne sont pas perdues —
              rechargez la page pour reprendre. Si le problème se répète,
              prévenez un administrateur.
            </p>
            {this.state.error?.message && (
              <p className="text-xs text-neutral-600 mb-4 break-words">
                Détail technique : {this.state.error.message}
              </p>
            )}
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 text-sm bg-white text-black hover:bg-neutral-200"
              >
                Recharger la page
              </button>
              <button
                onClick={() => this.setState({ hasError: false, error: null })}
                className="px-4 py-2 text-sm border border-white/20 text-[#F2F2F7] hover:bg-white/10"
              >
                Réessayer sans recharger
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
